import { useEffect, useRef } from "react";
import { useBlocker } from "react-router";

import { useBeforeunload } from "react-beforeunload";

// https://claritydev.net/blog/display-warning-for-unsaved-form-data-on-page-exit

export function useBlockerPrompt(hasUnsavedChanges) {
  const handleUnsavedChangesPrompt = () => {
    return !window.confirm(
      "It looks like you have been editing something" +
        // + (tag ? " [" + tag + "]" : "")
        ".\n\nIf you leave now, your changes will be lost."
    );
  };

  const handleBeforeUnload = (event) => {
    if (hasUnsavedChanges) {
      if (handleUnsavedChangesPrompt()) {
        event.preventDefault();
        event.returnValue = "";
      }
    }
  };

  const blocker = useBlocker(hasUnsavedChanges ? handleUnsavedChangesPrompt : false);
  const prevState = useRef(blocker.state);
  useBeforeunload(handleBeforeUnload);

  useEffect(() => {
    // Only reset the blocker after the user has proceeded with navigation
    // This prevents the blocker from being reset immediately when blocked
    if (prevState.current === "blocked" && blocker.state === "proceeding") {
      blocker.reset();
    }
    prevState.current = blocker.state;
  }, [blocker]);
}
